module.exports = __webpack_public_path__ + "img/share-pop2.55862293.png";